import ServiceDetailLayout from "@/components/site/ServiceDetailLayout";

export default function Reporting() {
  return (
    <ServiceDetailLayout
      eyebrow="Reporting & Attribution"
      title="Turn campaign activity into clear performance visibility."
      subtitle="Xadentra helps marketing teams build reporting structures that show what is working, where leads are coming from, and how campaigns influence pipeline."
      cta="Review My Reporting"
      seo={{
        title: "Marketing Reporting & Attribution | GA4, Adobe Marketo Engage, Salesforce — Xadentra",
        description: "Marketing reporting, GA4 event tracking, Adobe Marketo Engage program reporting, Salesforce campaign reporting, funnel visibility, lead source, and attribution.",
        path: "/services/reporting-attribution",
      }}
      sections={[
        {
          heading: "Tracking & instrumentation",
          items: [
            "GA4 event tracking and data layer design",
            "Google Tag Manager setup and governance",
            "UTM governance and source taxonomy",
            "Form and conversion event instrumentation",
            "Consent-aware tracking patterns",
          ],
        },
        {
          heading: "Platform reporting",
          items: [
            "Adobe Marketo Engage program performance reporting",
            "Salesforce campaign and pipeline reporting",
            "Funnel and lifecycle reporting",
            "MQL and SQL tracking with velocity",
            "Lead source and influence reporting",
          ],
        },
        {
          heading: "Dashboards & attribution",
          items: [
            "Executive dashboard planning",
            "Campaign performance summaries (weekly / monthly)",
            "Multi-touch attribution readiness",
            "Marketing-sourced and influenced reporting",
            "Pipeline-to-revenue narrative for the board",
          ],
        },
      ]}
      related={[
        { to: "/marketo-services", label: "Adobe Marketo Engage Services" },
        { to: "/services/salesforce-crm", label: "Salesforce & CRM Operations" },
        { to: "/services/martech-integration", label: "Martech & Data" },
      ]}
    />
  );
}
